<template>
  <component :is="layout">
    <router-view :key="$route.fullPath" />
  </component>
</template>

<script>
const default_layout = "login";
export default {
  computed: {
    layout() {
      let _layout = this.$route.meta.layout || default_layout;

      return `${_layout}-layout`;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius:10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
</style>